import React from 'react';

import BottomPopup from '../Popup/BottomPopup';
import DiscountInput from './DiscountInput';
import DiscountList from './DiscountList';
import { Button } from '../Button/Button';

import './DiscountPopup.scss';

interface DiscountPopupProps {
  isOpen: boolean;
  onClose: () => void;
  footerHeight: number;
  className?: string;
}

const DiscountPopup: React.FC<DiscountPopupProps> = ({
  isOpen,
  onClose,
  footerHeight,
  className,
}) => {
  return (
    <BottomPopup
      startBottom={footerHeight + 'px'}
      title="優惠與推薦"
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      noCrossButton={true}
    >
      <div>
        <DiscountInput />
      </div>
      <div>
        <DiscountList />
      </div>
      <Button
        className="discount-check-button"
        width="full"
        color="primary"
        onButtonClick={onClose}
      >
        <span>確定</span>
      </Button>
    </BottomPopup>
  );
};

export default DiscountPopup;
